import script from "./NominateAction.vue.js?vue&type=script&setup=true&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./NominateAction.vue?vue&type=script&setup=true&lang=js"
export * from "./NominateAction.vue.js?vue&type=script&setup=true&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./NominateAction.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__